import {Checkbox, Col, Form, Input, message, Row, Select} from "antd";
import {useEffect, useState} from "react";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {COMMON_DROPDOWN, PARAMETER_LIST} from "../../../util/Constants";
import {CustomerDto} from "../../../dto/CustomerDto";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import customerService from "../../../service/customerService";
import {MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR, MSG_FAILED_TO_FETCH_BANK_LIST_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {BankDetailDto} from "../../../dto/BankDetailDto";
import {toNumber} from "lodash";


interface BankInformationProps {
    customerMstDto: CustomerDto
}


const BankInformation = (props: BankInformationProps) => {
    const [form] = Form.useForm();

    useState({
        isSetSecondaryAccDataFilledAlready: false,
        secondaryAccData: {
            accountHolderName: "",
            accountNo: "",
            branchId: 0,
            bankId: 0
        }
    });
    const [isSecondaryAccountSelected, setSecondarySelected] = useState(false);
    const [bankList, setBankList] = useState<DropdownListDto[]>([]);
    const [branchListPrimary, setBranchListPrimary] = useState<DropdownListDto[]>([]);
    const [branchListSec, setBranchListSecondary] = useState<DropdownListDto[]>([]);

    useEffect(() => {
        getBankList()
        setFieldValues();
    }, []);
    const setFieldValues = () => {
        const bankDetailList: BankDetailDto[] = undefined != props.customerMstDto.bankDetailList ?
            props.customerMstDto.bankDetailList : []
        let primaryAcc: BankDetailDto;
        let secondaryAcc: BankDetailDto;

        if (bankDetailList.length > 0) {
            primaryAcc = bankDetailList[0]
            getBranchList(primaryAcc.bankId, true)
            form.setFieldsValue(
                {
                    accountHolderName: primaryAcc.accountHolderName,
                    accountNo: primaryAcc.accountNo,
                    bankId: toNumber(primaryAcc.bankId),
                    branchId: toNumber(primaryAcc.branchId),

                }
            )

            if (bankDetailList.length > 1) {
                secondaryAcc = bankDetailList[1]
                getBranchList(secondaryAcc.bankId, false)
                setSecondarySelected(true)
                form.setFieldsValue(
                    {
                        accountHolderNameSec: secondaryAcc.accountHolderName,
                        accountNoSec: secondaryAcc.accountNo,
                        branchIdSec: secondaryAcc.branchId,
                        bankIdSec: secondaryAcc.bankId,

                    }
                )

            } else {
                setSecondarySelected(false)
            }
        }


    }
    const getBankList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        loadCommonDropdownDataList(inputDropdownParameterDto, COMMON_DROPDOWN.BANK_LIST);
    }
    const getBranchList = (selectedBank: number, isPrimaryAcc: boolean) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                if (isPrimaryAcc) {
                    setBranchListPrimary(res.data.results.activeItemList)
                } else {
                    setBranchListSecondary(res.data.results.activeItemList)
                }
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto, type: COMMON_DROPDOWN) => {
        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                setType(type, res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setType = (type: COMMON_DROPDOWN, result: DropdownListDto[]) => {
        if (type == COMMON_DROPDOWN.BANK_LIST) {
            setBankList(result)
        }
    }
    return (
        <div>
            <Form
                className='form-input'
                layout={"vertical"}
                form={form}
                disabled={true}
            >
                <Row gutter={[32, 0]}>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Row>
                            <Col span={24} className='bank-account-header'>
                                <Checkbox checked disabled><h4 className='account-create-form-subheader'>Primary Bank
                                    Account Details</h4></Checkbox>
                            </Col>
                        </Row>
                        <Form.Item
                            label="Name of the Bank"
                            name={"bankId"}>
                            <Select placement='bottomLeft' placeholder={"Select bank name"}
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    options={bankList}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Branch"
                            name={"branchId"}>
                            <Select placement='bottomLeft' defaultSelected={""} placeholder={"Select branch"}
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    options={branchListPrimary}
                            />

                        </Form.Item>
                        <Form.Item
                            label="Account Number"
                            name={"accountNo"}>
                            <Input placeholder={"Enter account number"}/>
                        </Form.Item>
                        <Form.Item
                            label="Account Holder`s Name"
                            name={"accountHolderName"}>
                            <Input type="text" placeholder={"Enter account holder`s name"}/>
                        </Form.Item>

                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                        <Row>
                            <Col span={24} className='bank-account-header'>
                                <Checkbox checked={isSecondaryAccountSelected}>
                                    <h4 className='account-create-form-subheader'>Secondary Bank Account Details</h4>
                                </Checkbox>
                            </Col>
                        </Row>

                        <Form.Item
                            label="Name of the Bank"
                            name={"bankIdSec"}>
                            <Select placement='bottomLeft'
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    placeholder={"Select bank name"} options={bankList}/>

                        </Form.Item>
                        <Form.Item
                            label="Branch"
                            name={"branchIdSec"}>
                            <Select placement='bottomLeft'
                                    showSearch listHeight={180}
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: {
                                        label: any;
                                    }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                                    getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                    placeholder={"Select branch"} options={branchListSec}/>

                        </Form.Item>
                        <Form.Item
                            label="Account Number"
                            name={"accountNoSec"}>
                            <Input placeholder={"Enter account number"}/>
                        </Form.Item>
                        <Form.Item
                            label="Account Holder`s Name"
                            name={"accountHolderNameSec"}>
                            <Input placeholder={"Enter account holder`s name"}/>
                        </Form.Item>

                    </Col>
                </Row>

            </Form>

        </div>
    )
}
export default BankInformation